<template>
  <a-select v-bind="$attrs" v-model="tmpValue" v-on="$listeners">
    <a-icon slot="suffixIcon" type="down"/>
  </a-select>
</template>

<script>
import StateMixin from "./StateMixin";

export default {
  name: "BaseSelect",
  props: {
    emptyValue: [String, Number],
  },
  mixins: [StateMixin],
  computed: {
    tmpValue: {
      get() {
        return this.value === this.emptyValue ? undefined : this.value;
      },
      set(value) {
        this.value = value;
      }
    }
  }
}
</script>

<style lang="less">
.ant-select-selection__rendered {
  padding-right: 5px;
}
</style>
